import { ICellRenderer, ICellRendererParams } from '@ag-grid-community/core'

export const errorStatusRendererKey = 'errorStatusRendererKey'

export class ErrorStatusRenderer implements ICellRenderer {
  private eGui: HTMLElement = document.createElement('div')

  refresh(params: ICellRendererParams): boolean {
    this.eGui = document.createElement('div')
    this.eGui.classList.add('ellipsis')

    const icon = document.createElement('i')
    icon.classList.add('mdi', 'mdi-alert', 'text-warning')

    const text = document.createElement('span')
    text.innerText = params.getValue?.()

    this.eGui.appendChild(icon)
    this.eGui.appendChild(text)

    return true
  }

  getGui() {
    return this.eGui
  }

  init(params: ICellRendererParams) {
    this.refresh(params)
  }
}
